import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BlurLinearIcon from "@mui/icons-material/BlurLinear";
import ArticleIcon from "@mui/icons-material/Article";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { ConstructionOutlined } from "@mui/icons-material";

const accessControl = (company, navigationItem) => {
  if (navigationItem.label === "CA Schedules") {
    return company.companyType !== "investment";
  }

  if (
    ["Allocation Of Expenses", "Service Income Schedule"].includes(
      navigationItem.label
    )
  ) {
    return company.companyType === "investment";
  }
  return true;
};

export const NAV_ACTIONS = {
  NAVIGATE: "navigate",
  TOGGLE_SUBMENU: "toggleSubmenu",
};

const navBase = [
  {
    label: "Content Page",
    sectionKey: "contentPage",
    icon: <DashboardIcon />,
    action: NAV_ACTIONS.NAVIGATE,
  },
  {
    label: "Main Computation",
    sectionKey: "mainComputationData",
    icon: <ArticleIcon />,
    action: NAV_ACTIONS.NAVIGATE,
  },
  {
    label: "Detailed P&L",
    sectionKey: "detailPL",
    icon: <MonetizationOnIcon />,
    action: NAV_ACTIONS.NAVIGATE,
  },
  {
    label: "P&L Schedules",
    sectionKey: null,
    icon: <BlurLinearIcon />,
    action: NAV_ACTIONS.TOGGLE_SUBMENU,
    submenuKey: "pl",
  },
  {
    label: "CA Schedules",
    sectionKey: null,
    icon: <AccountBalanceIcon />,
    action: NAV_ACTIONS.TOGGLE_SUBMENU,
    submenuKey: "ca",
  },
  // {
  //   label: "Service Income Schedule",
  //   sectionKey: null,
  //   icon: <ConstructionOutlined />,
  //   action: NAV_ACTIONS.NAVIGATE,
  //   show: (company) => company.companyType === "investment"
  // }
];

export const navItems = navBase.map((item) => ({
  ...item,
  component: item.label,
  show: (company) => accessControl(company, { label: item.label }),
}));
